<template>
    <div class="col-sm-4" v-if="can('superadmin.logs')">
        <div class="card">
            <div class="card-header">
                <h1 class="card-title">{{i18n("Logs")}}</h1>
            </div>
            <div class="card-body">
                <ul class="list-unstyled grid-list">
                    <router-link to="/cashier-logs" tag="li" v-if="can('superadmin.logs')">
                        <a href="#" title="">Действие кассира</a>
                    </router-link>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "LogsCard",
    }
</script>

<style scoped>

</style>
